/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-06-11 17:37
 * @LastEditors: 1544807500@qq.com
 * @LastEditTime: 2025-06-11 18:04
 * @FilePath: \glyun_web_Vue3\src\router\report.js
 * @Description: 报表路由
 */
export default [
  {
    path: '/report',
    redirect: '/report/powerStationReport',
    name: 'report',
    component: () => import('../views/nav/index.vue'),
    children: [
      {//电站报表
        path: 'powerStationReport',
        name: 'powerStationReport',
        component: () => import('../views/report/powerStationReport/index.vue'),
        meta: {
          title: 'v2_plant_details_plant_report',
          routeAuthCode: 'A0300',
        }
      },
      {//电量报表
        path: 'electricityReport',
        name: 'electricityReport',
        component: () => import('../views/report/electricityReport/index.vue'),
        meta: {
          title: 'v2_report_energy_report',
          routeAuthCode: 'A0301',
        }
      },
      {//逆变器报表
        path: 'inverterReport',
        name: 'inverterReport',
        component: () => import('../views/report/inverterReport/index.vue'),
        meta: {
          title: 'v2_report_inverter_report',
          routeAuthCode: 'A0302',
        }
      },
      {//自定义报表
        path: 'customReport',
        name: 'customReport',
        component: () => import('../views/report/customReport/index.vue'),
        meta: {
          title: 'v2_report_custom_report_custom_report',
          routeAuthCode: 'A0303',
        }
      },
      {//报表订阅
        path: 'subscriptionReport',
        name: 'subscriptionReport',
        component: () => import('../views/report/subscriptionReport/index.vue'),
        meta: {
          title: 'v2_report_report_subscription_report_subscription',
          routeAuthCode: 'A0306',
        }
      },
      {//导出记录
        path: 'exportRecords',
        name: 'exportRecords',
        component: () => import('../views/report/exportRecords/index.vue'),
        meta: {
          title: 'v2_export_record_export_record',
          routeAuthCode: 'A0305',
        }
      },
    ],
  },
]